import GradientBorderRadius from "@/ui/gradient-border-radius";
import CopyTradeHeader from "./copy-trade-header";
import WalletDiscoveryFilterProvider from "@/providers/wallet-discovery-filter/wallet-discovery-filter-provider";
import CopyTradeTable from "./copy-trade-table";

import { Wallet } from "@/api/wallet-screener/types";
import { useState } from "react";

export interface DataItem extends Wallet {
  isActive: boolean;
}

const WalletScreenerPage = () => {
  const [isAllSelected, setIsAllSelected] = useState(false);

  return (
    <GradientBorderRadius overflow className="flex-1 flex w-full">
      <div className="flex-1 flex flex-col w-full gap-[0.625rem] pt-[0.625rem]">
        <WalletDiscoveryFilterProvider>
          <CopyTradeHeader
            isAllSelected={isAllSelected}
            setIsAllSelected={setIsAllSelected}
          />
          <CopyTradeTable
            isAllSelected={isAllSelected}
            setIsAllSelected={setIsAllSelected}
          />
        </WalletDiscoveryFilterProvider>
      </div>
    </GradientBorderRadius>
  );
};

export default WalletScreenerPage;
